import {
  getStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGet,
  HTTPValidationError,
  StudyAdherenceConfigMetadataResponse,
} from '@common/config/api/client'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useGetStudyAdherenceMetadata = (
  studyId: string,
): UseQueryResult<StudyAdherenceConfigMetadataResponse, AxiosError<HTTPValidationError>> => {
  return useQuery({
    queryKey: ['studyAdherenceMetadata', studyId],
    queryFn: async () => {
      const response = await getStudyAdherenceMetadataStudiesStudyIdAdherenceMetadataGet({
        path: { study_id: studyId },
        throwOnError: true,
      })
      return response.data
    },
  })
}
